import driversMetaReducer from './driversMetaReducer';

export default driversMetaReducer;
